import React, { useState } from 'react';
import {
    TableCell,
    Typography,
    TableRow
} from '@mui/material';
import ActionButtons from '../actionButton';
import { getKioskUserHistoryViewWatcher } from '../../../../redux/actionCreators/admin/reports';
import { useDispatch } from 'react-redux'


const KioskUserHistoryTableRow = ({ rowData, setPageChange }) => {
    const dispatch = useDispatch();

    const [status] = useState('list');

    const viewFunction = () => {
        setPageChange(true);

        let data1 = {
            "ACTION": "kioskFoodDetailsReport",
            "UserId": rowData.UserName,
            "Date": rowData.OrderDate?.split('/').reverse().join('-')
        }
        dispatch(getKioskUserHistoryViewWatcher(data1))
    }

    return (
        <>
            <TableRow
                hover
                tabIndex={-1}
            >
                <TableCell align="left">
                    <Typography variant='t14_600' >
                        {rowData.EmployeeName}
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography variant='t14_600'>
                        {rowData.UserName}
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography variant='t14_600'>
                        {rowData.cDivisionName}
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography variant='t14_600'>
                        {rowData.OrderDate}
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography variant='t14_600'>
                        {rowData.Kiosk}
                    </Typography>
                </TableCell>
                {/* <TableCell align="left">
                    <Typography variant='t14_600'>
                        {rowData.Breakfast}
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography variant='t14_600'>
                        {rowData.Dinner}
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography variant='t14_600'>
                        {rowData.Supper}
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography variant='t14_600'>
                        {rowData.Lunch}
                    </Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography variant='t14_600'>
                        {rowData.Snacks}
                    </Typography>
                </TableCell> */}
                <TableCell align="right">
                    <ActionButtons type={'kioskUserHistory'} status={status} viewFunction={viewFunction} />
                </TableCell>
            </TableRow>
        </>
    )
}

export default KioskUserHistoryTableRow